/**
 * How long the app waits, where waiting is the point.
 *
 * Durations that a person is meant to perceive, as opposed to animation curves. Named for what
 * they are for, so a screen cannot quietly invent its own idea of "a beat".
 */

/**
 * How long a sheet stays open after the choice inside it lands.
 *
 * Long enough to watch the mark arrive and know it was the row you meant, short enough that
 * nobody is waiting on it. Every sheet that takes an answer holds for this count, so a choice is
 * acknowledged at one speed across the app — the city, the week, and whatever comes next.
 *
 * Sheets used to close on the touch itself, which meant the mark never drew: the sheet was gone
 * before the row could show it had been chosen, and someone who had mis-tapped could not tell
 * which row they had hit.
 */
export const CHOICE_HOLD_MS = 800
